import React from "react";
import ProductList from "./ProductList";
import useUpdateListings from "../../hooks/useUpdateListings";

const ListingsList = ({ locationState, customHTML, setCaliber }) => {
  const { currentPage, allPages, productsInfo } =
    useUpdateListings(locationState);

  return (
    <ProductList
      currentPage={currentPage}
      allPages={allPages}
      productsInfo={productsInfo}
      locationState={locationState}
      customHTML={customHTML}
    />
  );
};

export default ListingsList;
